import { OFFER_PROCESSOR_CATEGORIES, ProcessorPreferenceKey } from '@consigli/types';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';

import { ProcessorPreferences } from '@/features/package-creation/components/processor-preferences';

import { CompareConfig } from './types';

interface RiskInsightGapsControlsProps {
  config: CompareConfig;
  onChange: (config: CompareConfig) => void;
}

export const RiskInsightGapsControls: FC<RiskInsightGapsControlsProps> = ({ config, onChange }) => {
  const { t } = useTranslation();
  const [advancedOpen, setAdvancedOpen] = useState(false);

  const setSelectedProcessors = (value: ProcessorPreferenceKey[]) => {
    onChange({ ...config, selectedProcessors: value });
  };

  return (
    <div className="w-full rounded-lg border border-day-light-2 bg-day-light-5 p-6">
      <h3 className="mb-4 text-lg font-semibold text-day-neutral-dark">
        {t('bid-review.compare.risk-insight-gaps-controls')}
      </h3>

      <div className="rounded-lg border border-day-light-2 p-4">
        <button
          type="button"
          onClick={() => setAdvancedOpen((value) => !value)}
          className="flex w-full items-start justify-between text-left"
          aria-expanded={advancedOpen}
        >
          <span className="flex flex-col">
            <span className="font-semibold text-day-neutral-dark">
              {t('bid-review.compare.advanced-controls-title')}
            </span>
            <span className="text-sm text-day-neutral-subtle">
              {t('bid-review.compare.advanced-controls-description')}
            </span>
          </span>
          {advancedOpen ? (
            <HiChevronUp size={20} className="mt-1 shrink-0 text-day-neutral-subtle" />
          ) : (
            <HiChevronDown size={20} className="mt-1 shrink-0 text-day-neutral-subtle" />
          )}
        </button>

        {advancedOpen && (
          <div className="mt-3">
            <ProcessorPreferences
              selectedProcessors={config.selectedProcessors}
              setSelectedProcessors={setSelectedProcessors}
              categories={OFFER_PROCESSOR_CATEGORIES}
            />
          </div>
        )}
      </div>
    </div>
  );
};
